import { forwardRef } from "react";

type FormTitleProps = {
  text: string;
};

export const FormTitle = forwardRef<HTMLDivElement, FormTitleProps>(
  (props, ref) => {
    return (
      <div {...props} ref={ref} className="my-4 text-[35px] font-semibold text-brand">
        {props.text}
      </div>
    );
  },
);

FormTitle.displayName = "FormTitle";
